/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import {
    ClockConfig,
    CustomHomepageGrid,
    HeaderWorldClock,
    HomePageCompanyLogo,
    HomePageRandomJoke,
    HomePageStarredEntities,
    HomePageToolkit,
    HomePageTopVisited,
    HomePageRecentlyVisited,
    WelcomeTitle,
    QuickStartCard,
  } from '@backstage/plugin-home';
import ContentImage  from './img/backstageSystemModel.png';
import { Content, Header, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import HomeIcon from '@material-ui/icons/Home';
import { Grid } from '@material-ui/core';
//import { MicrosoftCalendarCard } from '@backstage-community/plugin-microsoft-calendar';
  
  const clockConfigs: ClockConfig[] = [
    {
      label: 'NYC',
      timeZone: 'America/New_York',
    },
    {
      label: 'TX',
      timeZone: 'America/Chicago',
    },

  ];
  
  const timeFormat: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  
  const defaultConfig = [
/*
    {
      component: 'CompanyLogo',
      x: 0,
      y: 0,
      width: 12,
      height: 1,
     // movable: false,
      //resizable: false,
      //deletable: false,
    },
  
    {
      component: 'WelcomeTitle',
      x: 0,
      y: 1,
      width: 12,
      height: 1,
    },
*/
    {
      component: 'HomePageSearchBar',
      x: 0,
      y: 0,
      width: 12,
      height: 2,
      movable: true,
      resizable: true,
      deletable: false,

    },
    {
      component: 'HomePageToolkit',
      x: 0,
      y: 2,
      width: 2,
      height: 6,
      movable: true,
      resizable: true,
      deletable: false,
    },
/*
    {
      compnent: 'QuickStartCard',
      x: 0,
      y: 8,
      width: 2,
      height: 6,

    },
    */
  ];
  const languages = ['English'];
  export const HomePage  = (
    <Page themeId="home">
      <Header title={<WelcomeTitle language={languages} />} pageTitleOverride="Home" >
        <HeaderWorldClock
          clockConfigs={clockConfigs}
          customTimeFormat={timeFormat}
        />
      </Header>
      <Content>
        <CustomHomepageGrid config={defaultConfig}>
          <HomePageSearchBar />
          <HomePageRandomJoke />
          <HomePageStarredEntities />
          <HomePageToolkit
          tools={[
            {
              url: 'https://dev.azure.com/SWBC-FigWebDev/',
              label: 'Fig Technology Azure DevOps Orgnization',
              icon: <HomeIcon />,
            },
          ]}
        />
          <QuickStartCard image={<img src={ContentImage} alt="quick start" />} />
          <HomePageRandomJoke />
          <HomePageStarredEntities />
          <HomePageTopVisited />
          <HomePageRecentlyVisited />
          {/* <MicrosoftCalendarCard /> */}
        </CustomHomepageGrid>
        <Grid item xs={12} md={6}>
          <QuickStartCard title="Onboarding to the Catalog" modalTitle="Onboarding Quick Start" docsLinkTitle="Learn more with getting started docs" docsLink="https://backstage.io/docs/getting-started" image={<img src={ContentImage} alt="quick start" width="100%" height="100%" />} cardDescription="Backstage system model will help you create new entities" />
        </Grid>
      </Content>
    </Page>
  );

          /*
        <Grid container justifyContent="center" spacing={0}>
        <Grid container item xs={12} alignItems="center" direction="row">
            <HomePageSearchBar placeholder="Search" />
        </Grid>
        </Grid>
        */


        //<CustomHomepageGrid config={defaultConfig}>

/*
        <HomePageSearchBar />
        <HomePageToolkit
          tools={[
            {
              url: 'https://dev.azure.com/SWBC-FigWebDev/',
              label: 'Fig Technology Azure DevOps Orgnization',
              icon: <HomeIcon />,
            },
          ]}
        />
*/